<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col cols="12">
          <b-table
            :items="servicos"
            :fields="servicos.some(som => som.desconto > 0) ? colunas : colunas.filter(fil => fil.key != 'desconto')"
            class="tabela-servicos"
            bordered
            foot-clone
          >
            <template #head(servico)="">
              <span>Bonificação</span>
            </template>
            <template #cell(servico)="{ item }">
              <span>{{ item.servico.nome }}</span>
            </template>
            <template #cell(valorAuditar)="{ item }">
              <span>{{ totalServico(item) | converteValor }}</span>
            </template>
            <template #cell(desconto)="{ item }">
              <span v-if="!porcentagem">{{ item.desconto | converteValor }}</span>
              <span v-else>{{ item.desconto }}%</span>
            </template>
            <template #cell(subTotal)="{ item }">
              <span>{{ subTotalServico(item) | converteValor }}</span>
            </template>

            <template #foot(servico)="">
              <span>SubTotal</span>
            </template>
            <template #foot(valorAuditar)="">
              <span class="valor-total-servico">{{ valorTotalAuditarServicos | converteValor }}</span>
            </template>
            <template #foot(desconto)="">
              <span
                v-if="!porcentagem"
                class="valor-total-servico"
              >{{ valorTotalDesconto | converteValor }}</span>
              <span v-else>{{ valorTotalDesconto }}%</span>
            </template>
            <template #foot(subTotal)="">
              <span
                class="valor-total-servico"
                style="max-width: 300px; word-break: break-all;"
              >{{ valorSubTotalServicos | converteValor }}</span>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<style lang="scss">
.tabela-servicos {
  thead {
    tr {
      th {
        background-color: #e1e1e1 !important;
      }
    }
  }

  .form-control {
    padding: 0.438rem 0.7rem;
    height: 2.5rem;
  }

  th,
  td {
    padding: 0.5rem 0.2rem;
  }
}

.valor-total-servico {
  // justify-content: flex-end;
  font-size: 13.2px;
}

.cor-fundo {
  background-color: #ffffff !important;
}
</style>

<script>
export default {
  name: 'TabelaBonificacao',
  props: {
    servicos: {
      type: Array,
      default: () => [],
    },
    porcentagem: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      colunas: [
        {
          key: 'servico', label: 'Serviços', thStyle: 'width: 418px;padding: 0.5rem 0.2rem;', tdClass: 'cor-fundo',
        },
        {
          key: 'valorAuditar', label: 'Valor', thStyle: 'width: 149px; padding: 0.5rem 0.2rem;', tdClass: 'cor-fundo',
        },
        {
          key: 'desconto', label: 'Desconto', thStyle: 'width: 149px; padding: 0.5rem 0.2rem;', tdClass: 'cor-fundo',
        },
        {
          key: 'subTotal', label: 'Subtotal', thStyle: 'width: 259px; padding: 0.5rem 0.2rem;', tdClass: 'cor-fundo',
        },
      ],
    }
  },
  computed: {
    valorSubTotalServicos() {
      let valor = 0
      for (let index = 0; index < this.servicos.length; index += 1) {
        valor += this.subTotalServico(this.servicos[index])
      }
      return valor
    },
    valorTotalAuditarServicos() {
      let valor = 0
      for (let index = 0; index < this.servicos.length; index += 1) {
        valor += this.totalServico(this.servicos[index])
      }
      return valor
    },
    valorTotalDesconto() {
      return this.servicos.reduce((accumulator, currentValue) => accumulator + currentValue.desconto, 0)
    },
  },
  methods: {
    totalServico(item) {
      if (!this.porcentagem) {
        return item.valorAuditar + item.acrescimo
      }

      let valor = item.valorAuditar
      if (item.acrescimo && item.acrescimo > 0) {
        valor += (valor * (item.acrescimo / 100))
      }
      return valor
    },
    subTotalServico(item) {
      if (!this.porcentagem) {
        return (item.valorAuditar + item.acrescimo) - item.desconto
      }

      let valor = item.valorAuditar
      if (item.acrescimo && item.acrescimo > 0) {
        valor += (valor * (item.acrescimo / 100))
      }

      if (item.desconto && item.desconto > 0) {
        valor -= (valor * (item.desconto / 100))
      }
      return valor
    },
  },
}
</script>
